import { useState } from 'react'

import { useWorkspaceParam } from 'features/workspace/hooks/useWorkspaceParam'
import { useQuery } from 'providers/tanstack-query/useQuery'
import { fromDTO } from './api/mapper'
import { GET_GAM_ORDER_RETARGETING_DEALS_DELIVERY } from './api/query'
import { Data, Variables } from './api/types'
import {
  GamOrderRetargetingDealsDeliverySlice,
  UseGetGamOrderRetargetingDealsDelivery,
} from './types'

export const useGetGamOrderRetargetingDealsDelivery =
  (): UseGetGamOrderRetargetingDealsDelivery => {
    const [result, setResult] = useState<GamOrderRetargetingDealsDeliverySlice>()

    const { workspaceId } = useWorkspaceParam()

    const { isFetching, isLoading } = useQuery<Variables, Data>({
      onCompleted: async (data: Data) => {
        if (data.node?.gamOrderRetargetingDealsDelivery) {
          setResult(fromDTO(data.node.gamOrderRetargetingDealsDelivery))
        }
      },
      query: GET_GAM_ORDER_RETARGETING_DEALS_DELIVERY,
      variables: { id: workspaceId },
    })

    return {
      gamOrderRetargetingDealsDelivery: result,
      loading: isLoading || isFetching,
    }
  }
